// extracted by mini-css-extract-plugin
module.exports = {"newsletterMarketingCheckbox":"newsletterMarketingCheckbox__13moA"};